import { Loader2 } from 'lucide-react'

export function PageLoader() {
  return (
    <output
      className="flex min-h-screen flex-col items-center justify-center gap-5 bg-background"
      aria-live="polite"
    >
      <img src="/logomark.png" alt="Pelgo" className="h-8 w-auto" />
      <Loader2 className="h-5 w-5 animate-spin text-brand" aria-hidden="true" />
      <span className="sr-only">Loading...</span>
    </output>
  )
}
